<template>
  <Modal
    :title="editModalTitle"
    bottom-close-button-label="保存"
    :isCloseButtonDisabled="isSaveButtonDisabled"
    @close="save"
    @dismiss="$emit('close')"
  >
    <template v-slot:body>
      <div>
        <div class="form-group">
          <label class="form-control-label">事業所</label>
          <select class="form-control" v-model="state.group3.parentId">
            <option v-for="e in groups2" :key="e.id" :value="e.id">
              {{e.name}}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label class="form-control-label">
            部署名
          </label>
          <input type="text" class="form-control" v-model="state.group3.name" />
        </div>
        <div class="form-group">
          <label class="form-control-label">
            表示順
          </label>
          <input type="text" class="form-control" v-model="state.group3.dispOrder" />
        </div>
        <div class="form-group errors">
          <div class="error" v-for="(e, i) in httpErrorMsgs" :key="i">
            {{e}}
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, reactive } from 'vue';
import { useEditModalCommon } from 'src/composables/useEditModalCommon';
import type { AdminGroup2 } from 'src/models/group2';
import type { AdminGroup3Params } from 'src/models/apis/group3/adminGroup3Request';
import type { Group3InputModel } from 'src/models/group3';
import { createGroup3InitInputModel } from 'src/models/group3';

const props = defineProps<{
  isEditMode: boolean;
  group3: Group3InputModel;
  groups2: AdminGroup2[];
  isRequesting: boolean;
  httpErrorMsgs: string[];
}>();

const emit = defineEmits<{
  (e: 'create', createData: AdminGroup3Params): void;
  (e: 'update', id: number, updateData: AdminGroup3Params): void;
  (e: 'close'): void;
}>();

const state = reactive<{ group3: Group3InputModel }>({
  group3: createGroup3InitInputModel(),
});

const { editModalTitle } = useEditModalCommon(props, () => props.group3, (copied) => {
  state.group3 = copied;
});

const validateGroup3Form = (group3: Group3InputModel): boolean => {
  if (!Number.isInteger(group3.parentId)) return false;
  if (group3.name.length <= 0) return false;
  if (group3.dispOrder && !/^\d+$/.test(group3.dispOrder.toString())) return false;

  return true;
};

const isSaveButtonDisabled = computed<boolean>(() => {
  return props.isRequesting || !validateGroup3Form(state.group3);
});

const toPayload = (): AdminGroup3Params => {
  return {
    name: state.group3.name,
    parent_id: state.group3.parentId,
    disp_order: Number(state.group3.dispOrder),
  };
};

const createGroup3 = (): void => {
  if (isSaveButtonDisabled.value) return;

  emit('create', toPayload());
};

const updateGroup3 = (): void => {
  if (isSaveButtonDisabled.value || state.group3.id === null) return;

  emit('update', state.group3.id, toPayload());
};

const save = (): void => {
  if (props.isEditMode) {
    updateGroup3();
  } else {
    createGroup3();
  }
};
</script>

<style lang="scss" scoped>

</style>
